import * as React from 'react';
import { IconProps } from './IconProps';

const PlayWright: React.FC<IconProps> = ({ size, style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || 25}
      height={size || 25}
      fill="none"
      style={{ ...style }}
      viewBox="0 0 28 28"
      data-testid="playwright-icon"
    >
      <path
        fill="#000"
        fillOpacity={0.3}
        d="M9.71 15.455c-.87.247-1.441.68-1.817 1.112a3.8 3.8 0 0 1 1.493-.789c.665-.188 1.233-.187 1.702-.096v-.367a3.756 3.756 0 0 0-1.379.14Zm-1.857-3.083-3.23.85s.059.084.168.195l2.739-.722s-.039.5-.376.948c.637-.483.7-1.271.7-1.271Zm2.704 7.591c-4.546 1.225-6.95-4.044-7.679-6.778-.336-1.262-.483-2.218-.522-2.835a1.044 1.044 0 0 1 .002-.167c-.236.014-.349.136-.326.49.04.617.186 1.573.523 2.836.727 2.734 3.133 8.002 7.679 6.777.99-.266 1.733-.752 2.29-1.371a4.71 4.71 0 0 1-1.967 1.048Zm.855-10.816v.324h1.783c-.037-.115-.074-.218-.11-.324h-1.673Z"
      />
      <path
        fill="#000"
        fillOpacity={0.3}
        d="M13.594 11.812c.802.228 1.226.79 1.45 1.287l.895.254s-.122-1.741-1.697-2.188c-1.474-.419-2.38.818-2.49.979.428-.306 1.054-.556 1.842-.332Zm7.118 1.295c-1.475-.42-2.381.82-2.49.978.429-.305 1.054-.555 1.843-.33.8.227 1.224.789 1.449 1.287l.895.255s-.124-1.742-1.697-2.19Zm-.889 4.592-7.438-2.08s.081.409.39.937l6.262 1.75c.516-.297.786-.607.786-.607Zm-5.156 4.475c-5.89-1.579-5.178-9.082-4.225-12.638.393-1.466.796-2.555 1.13-3.285-.199-.04-.364.064-.528.397-.355.72-.809 1.893-1.249 3.535-.952 3.556-1.664 11.059 4.225 12.638 2.776.744 4.938-.387 6.55-2.162-1.53 1.386-3.484 2.163-5.903 1.515Z"
      />
      <path
        fill="#fff"
        d="M11.412 18.205v-1.514l-4.207 1.193s.31-1.806 2.505-2.429c.665-.188 1.233-.187 1.702-.097v-6.21h2.106a12.633 12.633 0 0 0-.637-1.634c-.308-.628-.624-.212-1.342.388-.505.423-1.782 1.323-3.704 1.841-1.922.518-3.476.38-4.124.268-.919-.158-1.4-.36-1.355.34.04.616.186 1.572.523 2.834.728 2.734 3.133 8.002 7.679 6.778 1.188-.32 2.026-.952 2.607-1.758h-1.753Zm-6.789-4.982 3.23-.851s-.093 1.242-1.305 1.562c-1.211.319-1.925-.711-1.925-.711Z"
      />
      <path
        fill="#fff"
        d="M23.57 9.22c-.839.146-2.854.33-5.343-.338-2.491-.666-4.143-1.833-4.798-2.381-.928-.778-1.336-1.318-1.738-.5-.355.72-.81 1.893-1.25 3.535-.952 3.556-1.664 11.06 4.225 12.638 5.888 1.578 9.023-5.277 9.975-8.833.44-1.642.633-2.885.686-3.686.06-.908-.564-.645-1.756-.436ZM11.74 12.16s.928-1.443 2.502-.996c1.575.447 1.697 2.189 1.697 2.189l-4.2-1.193Zm3.842 6.477c-2.769-.81-3.196-3.019-3.196-3.019l7.438 2.08s-1.501 1.74-4.242.94Zm2.63-4.537s.926-1.443 2.5-.994c1.574.448 1.698 2.19 1.698 2.19L18.21 14.1Z"
      />
      <path
        fill="#000"
        fillOpacity={0.2}
        d="m9.942 17.108-2.737.775s.297-1.693 2.314-2.364l-1.55-5.817-.134.041c-1.922.518-3.476.38-4.124.268-.919-.158-1.4-.36-1.355.34.04.616.186 1.572.523 2.834.728 2.734 3.133 8.002 7.679 6.778l.134-.042-.75-2.813Zm-5.319-3.885 3.231-.851s-.094 1.242-1.305 1.562c-1.212.319-1.926-.711-1.926-.711Z"
      />
      <path
        fill="#000"
        fillOpacity={0.2}
        d="m15.706 18.669-.125-.03c-2.769-.812-3.196-3.02-3.196-3.02l3.835 1.072 2.03-7.802-.024-.007c-2.49-.666-4.143-1.833-4.797-2.381-.928-.778-1.337-1.318-1.738-.5-.355.72-.81 1.893-1.25 3.535-.952 3.556-1.664 11.06 4.225 12.638l.12.027.92-3.532Zm-3.967-6.508s.928-1.443 2.502-.996c1.575.447 1.697 2.189 1.697 2.189l-4.2-1.193Z"
      />
      <path
        fill="#000"
        fillOpacity={0.3}
        d="m10.082 17.068-.734.208c.174.978.48 1.916.959 2.745.083-.019.166-.035.251-.058.223-.06.43-.135.629-.216-.536-.795-.89-1.711-1.105-2.679Zm-.286-6.885c-.378 1.408-.715 3.434-.622 5.466.166-.072.342-.139.537-.194l.136-.03c-.166-2.172.192-4.384.595-5.889.103-.38.205-.735.307-1.065a9.514 9.514 0 0 1-.543.323c-.136.42-.274.88-.41 1.389Z"
      />
    </svg>
  );
};
export default PlayWright;
